import React from 'react';
import { useComponents } from '@tencent/dz-elements';
var HospitalUI = function (props) {
    var test = props.test;
    var View = useComponents().View;
    return React.createElement(View, null,
        "HospitalUI ",
        test);
};
export default HospitalUI;
